<template>
    <div>
        <div id="figures" v-if="location == 1">
            <img src="/assets/img/figures-g-green-hor.svg" class="figure girl-green" />
            <img src="/assets/img/figures-g-yellow-hor.svg" class="figure girl-yellow" />
            <img src="/assets/img/figures-g-b-hor.svg" class="figure girl-boy" />
            <img src="/assets/img/figures-b-g-hor.svg" class="figure boy-girl" />
        </div>

        <div id="figures" v-if="location == 2">
            <img src="/assets/img/figures-g-green-kus.svg" class="figure girl-green" />
            <img src="/assets/img/figures-g-yellow-kus.svg" class="figure girl-yellow" />
            <img src="/assets/img/figures-g-b-kus.svg" class="figure girl-boy" />
            <img src="/assets/img/figures-b-g-kus.svg" class="figure boy-girl" />
        </div>


        <section class="offer page-wrapper-inner">
            <div class="block">

                <div>
                    <label class="subtitle horgen" v-if="location == 1">Horgen</label>
                    <label class="subtitle kuesnacht"  v-if="location == 2">Küsnacht</label>

                     <h2>{{ trans.global.holidaycare[lang] }}</h2>

                </div>

                <div class="switchbox">
                    <!-- <h3>Anmelden</h3> -->
                    <div class="flex">
                        <a class="btn btn-big" :href="'/register/' + (location == 1 ? 'horgen/1/holiday_intern' : 'kuesnacht/2/holiday_intern') + (lang == 'en' ? '/en':'') ">
                           <p v-html="trans.holidaycare.laksidekind[lang]"></p>
                        </a>

                        <a class="btn btn-big" :href="'/register/' + (location == 1 ? 'horgen/1/holiday_extern' : 'kuesnacht/2/holiday_extern') + (lang == 'en' ? '/en':'') ">
                             <p v-html="trans.holidaycare.nonlaksidekind[lang]"></p>
                        </a>
                    </div>
                </div>

                <br><br><br>
            </div>
        </section>

         <div class="teaser-wrapper">
            <h3 class="title"></h3>
            <div class="grid">
                 <div class="teaser">
                    <p>{{ trans.teaser.about_pri.text[lang] }}</p>
                    <a :href="trans.teaser.about_pri.link[location][lang]" target="_blank">{{ trans.teaser.about_pri.linktext[lang] }}</a>
                </div>
                <div class="teaser" v-if="location != 2">
                    <p>{{ trans.teaser.video_pri.text[lang] }}</p>
                    <a :href="trans.teaser.video_pri.link[location][lang]" target="_blank">{{ trans.teaser.video_pri.linktext[lang] }}</a>
                </div>
            </div>
        </div>

    </div>
</template>
    
    
   

<script>


    export default {


        data: function() {
            return  {
              
            }
        },
        props: {
            session: {
                type: String,
                required: true
            },
            location: {
                type: Number,
                required: true
            },
            lang: {
                type: String,
                required: true
            },
            trans: {
                type: Object,
                required: true
            },
        },
       
       

    }
</script>
